import {useQuery} from '@tanstack/react-query'

import {TapApiClient} from '#/lib/api/tap'
import {useSession} from '#/state/session'
import {STALE} from '.'

export const tapTagsQueryKeyRoot = 'tap-tags'
// Version added to clear stale cache after API format change
export const tapTagsQueryKey = [tapTagsQueryKeyRoot, 'v2']

export function useTapTagsQuery() {
  return useQuery({
    queryKey: tapTagsQueryKey,
    queryFn: async () => {
      console.log('[tap-tags] Fetching tags (public endpoint)...')
      try {
        const client = new TapApiClient()
        // Don't pass accessToken - this is a public endpoint
        const tags = await client.getAllTags()
        console.log('[tap-tags] Tags fetched successfully:', {
          count: tags.length,
          tags: tags.map(t => ({slug: t.slug, createdAt: t.createdAt, postCount: t.postCount})),
        })
        return tags
      } catch (error) {
        console.error('[tap-tags] Failed to fetch tags:', {
          error: error instanceof Error ? error.message : String(error),
          errorType: error?.constructor?.name,
          stack: error instanceof Error ? error.stack : undefined,
        })
        throw error
      }
    },
    staleTime: STALE.MINUTES.FIVE,
    // Force refetch to clear any cached errors
    retry: 3,
    retryDelay: 1000,
  })
}
